import { useGameStore } from '@/store/gameStore';
import { TitleScreen } from '@/components/game/TitleScreen';
import { CharacterCustomizer } from '@/components/game/CharacterCustomizer';
import { GameWorld } from '@/components/game/GameWorld';
import { SettingsScreen } from '@/components/game/SettingsScreen';

const Index = () => {
  const { screen } = useGameStore();

  return (
    <div className="w-full h-screen overflow-hidden">
      {screen === 'title' && <TitleScreen />}
      {screen === 'customize' && <CharacterCustomizer />}
      {screen === 'game' && <GameWorld />}
      {screen === 'settings' && <SettingsScreen />}
    </div>
  );
};

export default Index;